export default __webpack_public_path__ + "static/media/tab01.082a64bc.png";